import { Button, Modal, ModalHeader, ModalBody, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import { useForm } from "react-hook-form";
import { Search } from 'react-bootstrap-icons';
import { useCreateOrderMutation, useGetClientsByPhoneMutation } from "../../features/CallApi";
import { useState } from "react";
import LoadScreen from '../UI/LoadScreen';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const OrderCreate = ({ modal, setModal, basket, resetBasket }) => {
    const [getClientsByPhone, { isLoading: isPosting }] = useGetClientsByPhoneMutation();
    const [createOrder] = useCreateOrderMutation()
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
    // const [registred, setRegistred] = useState(false);
    const [client, setClient] = useState();
    // const [postError, setPostError] = useState();
    const navigate = useNavigate();

    const getCliet = async (e) => {
        const phone = e.currentTarget.closest("div").querySelector("input").value
        getClientsByPhone(phone).then((response) => {
            if (response.error?.data) {
                console.log(response)
                setClient(null)
            }
            else {
                setClient(response.data)
            }
        }).catch((e) => {
            console.log(e)
        })
        e.target.closest("button").classList.add("d-none")
        e.target.closest(".card-body").querySelector("[name=firstName]").value = client?.firstName
    }

    useEffect(() => {
        if (client) {
            setValue("firstName", client ? client.firstName : "")
            setValue("lastName", client ? client.lastName : "")
            setValue("patronymic", client ? client.patronymic : "")
            setValue("email", client ? client.email : "")
            setValue("seriesDoc", client ? client.seriesDoc : "")
            setValue("numberDoc", client ? client.numberDoc : "")
        }
    }, [client])
    const toggle = () => setModal(!modal);

    const create = (data) => {
        const body = {
            client: data,
            basket: basket
        }
        console.log(body)
        createOrder(body).unwrap().then((response) => {
            resetBasket()
            reset()
            navigate(`/admin/orders/details/${response}`)
        })
    }

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} size='lg'>
                <ModalHeader toggle={toggle}>Оформление заказа</ModalHeader>
                <ModalBody>
                    <div>
                        <div>
                            {isPosting ? <LoadScreen /> :
                                <Card className="">
                                    <CardHeader >
                                        <div className={'d-flex justify-content-center'}>
                                            <h3 className={'flex-fill text-center'}>Анкета гостя</h3>
                                        </div>
                                    </CardHeader>
                                    <form onSubmit={handleSubmit(create)}>
                                        <CardBody>
                                            <div className="mb-3 d-flex">
                                                <div className="form-group flex-fill m-1">
                                                    <label htmlFor="lastName" className="form-label">Фамилия</label>
                                                    <input type="text" placeholder="Фамилия" className="form-control"
                                                        {...register("lastName", { required: { value: true, message: "Поле \"Фамилия\" не может быть пустым" } })} />
                                                    {errors.lastName && <span className='text-danger'>{errors.lastName?.message}</span>}
                                                </div>
                                                <div className="form-group flex-fill m-1">
                                                    <label htmlFor="firstName" className="form-label">Имя</label>
                                                    <input type="text" defaultValue={client?.firstName} className="form-control" placeholder="Имя" {...register("firstName",
                                                        { required: { value: true, message: "Поле \"Имя\" не может быть пустым" } })} />
                                                    {errors.firstName && <span className='text-danger'>{errors.firstName?.message}</span>}
                                                </div>
                                                <div className="form-group flex-fill m-1">
                                                    <label htmlFor="patronymic" className="form-label">Отчество</label>
                                                    <input type="text" className="form-control" placeholder="Отчество" {...register("patronymic", {})} />
                                                </div>
                                            </div>
                                            <div className="mb-3 d-flex">
                                                <div className="form-group flex-fill m-1">
                                                    <label className="form-label">Телефон</label>
                                                    <div className='input-group'>
                                                        <input type="tel" className="form-control" placeholder="+79999999999" {...register("phone",
                                                            {
                                                                required: { value: true, message: "Поле \"Телефон\" не может быть пустым" },
                                                                onChange: (e) => {
                                                                    e.target.closest("div").querySelector("button").classList.remove("d-none")
                                                                }
                                                            })} />
                                                        <Button className='d-none' onClick={(e) => {
                                                            getCliet(e)
                                                        }}><Search size={14} /></Button>
                                                    </div>
                                                    {errors.phone && <span className='text-danger'>{errors.phone?.message}</span>}
                                                </div>
                                                <div className="form-group flex-fill m-1">
                                                    <label className="form-label">E-Mail</label>
                                                    <input type="email" className="form-control" placeholder="Email" {...register("email", {
                                                        pattern: { value: /^\S+@\S+$/i, message: "Некорректно указан E-Mail" },
                                                    })}
                                                    />
                                                    {errors.email && <span className='text-danger'>{errors.email?.message}</span>}
                                                </div>
                                            </div>
                                            <div className="mb-1 ms-1 d-flex border-top">Паспорт (или документ удостоверяющего личность)</div>

                                            <div className="mb-3 d-flex">
                                                <div className="form-group flex-fill m-1">
                                                    <label className="form-label">Серия</label>
                                                    <input type="text" className="form-control" placeholder="Серия" {...register("seriesDoc", {})} />
                                                </div>
                                                <div className="form-group flex-fill m-1">
                                                    <label className="form-label">Номер</label>
                                                    <input type="text" className="form-control" placeholder="Номер" {...register("numberDoc", {})} />
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardFooter>
                                            <input type="submit" id="submit" value="Оформить" className="btn btn-info m-1 text-white" />
                                        </CardFooter>
                                    </form >
                                </Card>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}